export const DEFAULT_STATSIG_ECOMM_SSR_DYNAMIC_CONFIG = {
  isSignupOTPRequired: true,
  globalSignOutEnabled: true,
  disableCartEDDMessaging: true,
  useCustomerSearch: false,
  disableForceEDDForAgeRestrictedProducts: false,
  disableAgeVerification: false,
  showMultipleShipmentsInOrderDetails: false,
  showMultipleShipmentsInOrderList: false,
  useEfaKeyForEfaRecommendations: true,
  imageUploadLimitReturn: 3,
  isNewCartCollectionsEnabled: false,
  hiddenMenuItems: [] as { filterKey: string; filterValue: string }[],
  fmoOrderSearchPeriodValue: 2,
  fmoOrderSearchPeriodUnit: 'years' as 'days' | 'years',
  fingerprintCacheTTL: 86400000, // 1 day
  enableFMOForGuestUser: false,
  enableCarrierAlignedStatus: false,
  showD2cReviewsOnB2B: false,
  // Country codes (ISO-3166 alpha-2) whose addresses have no customer-facing province code,
  // so it's hidden per-address on order details (e.g. UK "ENG"). Mirrors checkout's no-state-field list.
  countriesWithoutProvinceCode: ['GB'] as string[],
  enableWriteReviewOnB2BPdp: false,
}
